/**
 * Display of a campaign's "Uplift" — Sales minus "Normal ordering" (what the
 * recipients would typically have ordered over the same period). See
 * docs/features/campaign-results-enrichment/12_normal_ordering_uplift.md.
 */

import { formatCurrencyGbp } from "./formatters";

/** "+£59,686 (+19%)", "−£205 (−15%)", or just "+£700" when there is no
 * percentage (a normal of £0 has none); "—" when uplift isn't computable.
 * The sign is always shown so a negative uplift reads plainly. */
export function formatUplift(
  upliftAmount: number | null,
  upliftPct: number | null,
): string {
  if (upliftAmount === null) return "—";
  const amount = `${signOf(upliftAmount)}${formatCurrencyGbp(Math.abs(upliftAmount))}`;
  if (upliftPct === null) return amount;
  return `${amount} (${signOf(upliftPct)}${Math.round(Math.abs(upliftPct))}%)`;
}

function signOf(value: number): string {
  // U+2212 minus, so a negative lines up with the plus in a column.
  if (Math.round(value) === 0) return "";
  return value > 0 ? "+" : "−";
}
